export default __webpack_public_path__ + "static/media/flag_es.4ba7dfef.svg";